import { Directive, ElementRef, OnInit, Renderer2, Input, HostListener } from '@angular/core';
@Directive({
  selector: '[vmChallengerDynamicLineHeight]',
})
export class LineHeightDirective implements OnInit {
  @Input() lineHeightLength: number;

  baseHeight: any = 20;
  cardWidth = 228;
  public innerWidth: any;
  constructor(private elementRef: ElementRef, private renderer2: Renderer2) {}

  @HostListener('window:resize')
  onWinResize() {
    if (window.innerWidth < 470) {
      this.updateHeight();
    }
  }

  ngOnInit() {
    this.updateHeight();
  }

  private updateHeight() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 1024) {
      this.cardWidth = 132;
      this.baseHeight = 18;
    }
    const allocatePixel = Math.ceil((this.cardWidth / 100) * 87);
    const calculateLineHeightInPixel = this.lineHeightLength * 8;
    const line = Math.ceil(calculateLineHeightInPixel / allocatePixel);
    const height = (this.baseHeight * line) / 16 + 'rem';
    const marginCalculation = (this.cardWidth - allocatePixel) / 2 / 16 - 0.15 + 'rem';
    this.renderer2.setStyle(this.elementRef.nativeElement, 'height', height);
    this.renderer2.setStyle(this.elementRef.nativeElement, 'margin-left', marginCalculation);
    this.renderer2.setStyle(this.elementRef.nativeElement, 'margin-right', marginCalculation);
  }
}
